/**
 * Homepage extensions for the new Backstage frontend system.
 * Custom dashboard page for the IntelliPact Admin Portal.
 *
 * @packageDocumentation
 */

import type { JSX } from 'react';
import {
  PageBlueprint,
  createRouteRef,
  type ExtensionDefinition,
} from '@backstage/frontend-plugin-api';

/**
 * Route reference for the homepage.
 */
export const homeRouteRef = createRouteRef();

/**
 * Custom homepage page extension.
 * Renders the IntelliPact Admin Portal dashboard with tenant widgets.
 */
const homePage = PageBlueprint.make({
  params: {
    path: '/',
    routeRef: homeRouteRef,
    loader: async (): Promise<JSX.Element> => {
      const { HomePage } = await import('../components/home/HomePage');
      return <HomePage />;
    },
  },
});

/**
 * Homepage extensions exported as an array for easy registration.
 */
export const homepageExtensions: ExtensionDefinition[] = [homePage];
